// components/ReviewPrompt.tsx — the sentiment-gated native review prompt.
// `appName` is interpolated into the headings; app names stay untranslated
// (brand name), only the surrounding copy is localized.
export const reviewPrompt = {
  negative: {
    heading: "Thanks — what can we improve in {{appName}}?",
    body: "Tell us what's not working and we'll get on it — your feedback goes straight to the team.",
    contactSupport: "Contact support",
    orLeaveReview: "Or leave a review",
  },
  positiveFallback: {
    heading: "Enjoying {{appName}}?",
    body: "If you have a moment, you can share your experience on the Shopify App Store. It helps other merchants and helps us improve.",
    writeReview: "Write a review",
  },
  ask: {
    heading: "How's {{appName}} working for you?",
    body: "We'd love to hear how it's going.",
    goingWell: "Going well",
    couldBeBetter: "Could be better",
  },
};
